import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/account-settings/")({
    component: RouteComponent,
    beforeLoad: async () => {
        return redirect({
            to: `/dashboard/account-settings/account`,
        });
    },
});

function RouteComponent() {
    return null;
}
